var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 14H5C4.448 14 4 13.552 4 13C4 12.448 4.448 12 5 12H11C11.552 12 12 12.448 12 13C12 13.552 11.552 14 11 14Z",
    fill: "#282D37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9H3C2.448 9 2 8.552 2 8C2 7.448 2.448 7 3 7H13C13.552 7 14 7.448 14 8C14 8.552 13.552 9 13 9Z",
    fill: "#282D37"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 4H1C0.448 4 0 3.552 0 3C0 2.448 0.448 2 1 2H15C15.552 2 16 2.448 16 3C16 3.552 15.552 4 15 4Z",
    fill: "#282D37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.d94444a3fec83d74ef7c126e0a11bd30.svg";
export { ForwardRef as ReactComponent };